module.exports = __webpack_public_path__ + "img/v2-redesign-roadshows.4083bb76.png";